import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Home as HomeIcon } from 'lucide-react';
import SEO from '../components/SEO';
import Header from '../components/Header';
import Footer from '../components/Footer';

const NotFound = () => {
  return (
    <div className="min-h-screen bg-slate-50 flex flex-col" data-testid="not-found-page">
      <SEO
        title="Page Not Found (404) | OwlWorkLabs"
        description="The page you're looking for doesn't exist or has moved. Return to OwlWorkLabs — a UK venture studio building intelligent systems for real-world impact."
        canonical="https://www.owlworklabs.com/404"
      />
      <Header />
      <main className="flex-1 flex flex-col items-center justify-center px-6 text-center pt-36 pb-28">
        <p className="text-[7rem] sm:text-[11rem] font-bold leading-none tracking-tight text-slate-900">404</p>
        <h1 className="text-2xl sm:text-3xl font-bold text-slate-900 mt-2">This page took a different path.</h1>
        <p className="text-base text-slate-600 max-w-md mx-auto mt-4 leading-relaxed">
          The page you're looking for doesn't exist or may have moved. Let's get you back to something useful.
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3 mt-10">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 px-7 py-3.5 bg-slate-900 text-white font-semibold rounded-full hover:bg-slate-800 transition-colors"
            data-testid="notfound-home-link"
          >
            <HomeIcon className="w-4 h-4" /> Back to Home
          </Link>
          <Link
            to="/#ventures"
            className="inline-flex items-center justify-center gap-2 px-7 py-3.5 bg-white text-slate-900 font-medium rounded-full border border-slate-200 hover:border-slate-400 transition-colors"
            data-testid="notfound-ventures-link"
          >
            Explore our ventures <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default NotFound;
